/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface DeleteRegisteredBrowser$Request {
    userId: number;
    userPlaceId: string;
}

export interface DeleteRegisteredBrowser$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const deleteRegisteredBrowserRequest = createAction<PayloadData<void, DeleteRegisteredBrowser$Request>>('DELETE_REGISTERED_BROWSER__DELETE_REGISTERED_BROWSER__REQUEST');
export const deleteRegisteredBrowserSuccess = createAction<PayloadData<void, DeleteRegisteredBrowser$Request>>('DELETE_REGISTERED_BROWSER__DELETE_REGISTERED_BROWSER__SUCCESS');
export const deleteRegisteredBrowserFailure = createAction<PayloadData<Error, DeleteRegisteredBrowser$Request, true>>('DELETE_REGISTERED_BROWSER__DELETE_REGISTERED_BROWSER__FAILURE');

export const deleteRegisteredBrowserActions = [
    deleteRegisteredBrowserRequest,
    deleteRegisteredBrowserSuccess,
    deleteRegisteredBrowserFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {string} meta.userPlaceId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const deleteRegisteredBrowser = (meta: DeleteRegisteredBrowser$Request, config?: DeleteRegisteredBrowser$Config) => {
    return {
        CALL_API: {
            types: deleteRegisteredBrowserActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/users/${meta.userId}/browser-registration/${meta.userPlaceId}/deactivate`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

